import React, { useEffect, useRef, useState } from "react";
import SelectBox from "../../../../components/elements/form/selectBox";
import { useSpearPartsApi } from "../../../../store/api/hooks/spearPartsApiHook";
import { useCommonApi } from "../../../../store/api/hooks/commonApiHook";
import { useAssetsApi } from "../../../../store/api/hooks/assetsApiHook";
import Currency from "../../../../components/currency";

interface CreatePurchasedRequestAssetsProps {
    data?: any;
    onUpdate?: (data: Array<any>) => void;
}
const CreateReceiptAssets: React.FC<CreatePurchasedRequestAssetsProps> = ({ data, onUpdate = (data: Array<any>) => { } }) => {
    const divRef = useRef<any>(null);
    const sparePartsAPI = useSpearPartsApi();
    const commonApi: any = useCommonApi();
    const assetsApi:any = useAssetsApi();

    const blankpartmodel = {
        assetName: null,
        unitID: 5,
        unitCode: `Each`,
        unitCost: 0,
        orderedQty: 0,
        deliveredQty: 0,
        receivingQty: 0,
        totalValue: 0,
    };

    const [showSuggestion, setShowSuggestion] = useState<boolean>(false);
    const [assetItems, setAssetItems] = useState<any[]>(data || []);
    const [lastSearchAssets, setLastSearchAssets] = useState([]);
    const [assetSuggestions, setAssetSuggestions] = useState<any[]>([]);
    const [vendorList, setVendorList] = useState<any[]>([]);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);

    const onOutsideClick = () => {
        handleOnClickCellEdit()
        setShowSuggestion(false);
    }

    const handleOnClickCellEdit = (identifier: string = ``, e: any = null) => {
        if (identifier) {
            const cellElement = document.querySelector(`#${identifier}`) as HTMLDivElement;
            const previewElement = cellElement.querySelector(`.preview-value`) as HTMLDivElement;
            const editElement = cellElement.querySelector(`.edit-value`) as HTMLDivElement;
            if (previewElement && editElement) {
                if (cellElement.id === `${identifier}`) {
                    if (!previewElement.classList.contains(`hidden`)) previewElement.classList.add(`hidden`);
                    if (editElement.classList.contains(`hidden`)) editElement.classList.remove(`hidden`);
                }
            }
        }

        //resetOthersCellEditState(`part-item-name-${index}`);
        const editableList = document.querySelectorAll(`.editable`) as NodeListOf<HTMLDivElement>
        //console.log("editableList", editableList);
        for (let i = 0; i < editableList.length; i++) {
            const editableCell = editableList[i];
            const preview = editableCell.querySelector(`.preview-value`) as HTMLDivElement;
            const edit = editableCell.querySelector(`.edit-value`) as HTMLDivElement;
            if (editableCell.id !== `${identifier}`) {
                if (preview.classList.contains(`hidden`)) preview.classList.remove(`hidden`);
                if (!edit.classList.contains(`hidden`)) edit.classList.add(`hidden`);
            }
        }        
    };

    const handleAssetsSearch = async (inputval: any) => {
        if (inputval && (`` + inputval).length > 2) {
            const assetsrespp:any = await new Promise((resolve, reject) => {
                assetsApi.getAssetsList({
                    pageSize: 10,
                    pageNumber: 1,
                    searchParam: inputval,
                    statusIDs: [1, 2, 3, 4, 5, 6].join(`,`)
                }, (resp: any) => {
                    if (resp && resp.code === 200 && resp.successful === true && resp.hasOwnProperty(`assetList`) && Array.isArray(resp.assetList) && resp.assetList.length > 0) {
                        const bindAssets = resp.assetList.map((asset: any) => {
                            return {
                                value: asset.name,
                                label: asset.name,
                            };
                        });
                        setLastSearchAssets(resp.assetList);
                        resolve(bindAssets);
                    } else {
                        resolve([]);
                    }
                }, (error: any) => {
                    reject([])
                })
            });      
            if (assetsrespp.length > 0) {
                setShowSuggestion(true);
            } else {
                setShowSuggestion(false);
            }        
            setAssetSuggestions(assetsrespp);  
        } else {
            setAssetSuggestions([]);  
            setShowSuggestion(false);
        }
    };

    const handleVendorSearch = async (inputval: any): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            commonApi.GetServiceprovidertList({}, (resp: any) => {
                if (resp && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0) {                    
                    resolve(resp.vendorList);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([])
            })
        });
    };

    const handleKeyDown = (e: any, keyindex:number) => {
        if (!showSuggestion) return;
            switch (e.key) {
                case 'ArrowDown':
                    setHighlightedIndex((prev) => prev < assetSuggestions.length - 1 ? prev + 1 : 0);
                break;
                case 'ArrowUp':
                    setHighlightedIndex((prev) => prev > 0 ? prev - 1 : assetSuggestions.length - 1);
                break;
                case 'Enter':
                    if (highlightedIndex >= 0) {
                        const updatedAssets = [...assetItems];
                        updatedAssets[keyindex].assetName = assetSuggestions[highlightedIndex].label;
                        setAssetItems(updatedAssets);
                        onUpdate(updatedAssets);
                        setShowSuggestion(false);                        
                }
                break;            
                default:
                break;
        }
    }

    const init_page_data = async () => {
        const vendorlist = await handleVendorSearch(``);
        setVendorList(vendorlist);
    };

    useEffect(() => {
        // set dummy data
        init_page_data();
        /*
        setAssetItems([{
            assetName: `Steel Rod`,
            unitID: 5,
            unitCode: `Each`,
            unitCost: 100,
            orderedQty: 10,
            deliveredQty: 6,
            receivingQty: 4,
            totalValue: 1000
        }, {
            assetName: `Aluminum Sheet`,
            unitID: 5,
            unitCode: `Each`,
            unitCost: 250,
            orderedQty: 20,
            deliveredQty: 15,
            receivingQty: 5,
            totalValue: 5000
        }, {
            assetName: `Copper Wire`,
            unitID: 5,
            unitCode: `Each`,
            unitCost: 75,
            orderedQty: 30,
            deliveredQty: 30,
            receivingQty: 0,
            totalValue: 2250
        }, {
            assetName: `Iron Pipe`,
            unitID: 5,
            unitCode: `Each`,
            unitCost: 120,
            orderedQty: 12,
            deliveredQty: 8,
            receivingQty: 4,
            totalValue: 1440
        }]);
        */
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (divRef.current && !divRef.current.contains(event.target)) {
                onOutsideClick();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onOutsideClick]);

    useEffect(() => {
        const handleKeyDown = (event: any) => {
            if (event.key === 'Escape') {
                onOutsideClick();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onOutsideClick]);


    return (
        <div>
            <div className="flex justify-between items-center mt-1">
                <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>LINE ITEMS</h4>                
            </div>
            {/* total width 849px */}
            <div className={`border border-[#043E6133] rounded-[5px] parts-table`}>
                <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>                    
                    <div className={`w-[495px] min-w-[495px] max-w-[495px] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Item Name</div> {/* 200px */}
                    <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Unit Cost</div> {/* 112px */}                    
                    <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Ordered Qty</div> {/* 112px */}                    
                    <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Delivered Qty</div> {/* 112px */}                    
                    <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end sticky right-28`}>Receiving Qty</div> {/* 112px */}
                    <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end sticky right-0`}>Total Value</div> {/* 112px */}
                </div>
                <div className={``} ref={divRef}>
                    {assetItems.length === 0 && (
                        <div className={`flex items-center justify-center h-24 text-gray-500`}>
                            No assets added yet.
                        </div>
                    )}
                    {assetItems.map((asset, index) => (
                        <div className={`flex items-center flex-nowrap`} key={`asset-item-${index}`}>                            
                            <div className={`w-[495px] min-w-[495px] max-w-[495px] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col bg-[#F9F9F9] cursor-not-allowed ${index < (assetItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                <div className={`preview-value line-clamp-1`} title={asset.assetName}>{asset.assetName || `--`}</div>                                
                            </div>
                            <div className={`w-28 min-w-28 max-w-28 font-normal text-[#42484B] bg-white text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-end flex-col editable cursor-pointer ${index < (assetItems.length - 1) ? `border-b border-[#043E6133]` : ``}`} id={`asset-item-cost-${index}`} onClick={(e: any) => {
                                handleOnClickCellEdit(`asset-item-cost-${index}`, e);
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <div className={`text-right`}>
                                    <div className={`preview-value`} title={(+asset.unitCost > 0)? (`Unit Cost: $` + asset.unitCost): `Click here to edit`}><Currency currency="USD" value={asset.unitCost || 0} /></div>
                                    <div className={`edit-value hidden`}>
                                        <input
                                            type="number"
                                            className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right input-no-spinner`}
                                            value={asset.unitCost}
                                            min={0}
                                            step="0.01"
                                            onInput={(e: any) => {
                                                const newCost = e.target.value;
                                                const updatedAssets = [...assetItems];
                                                updatedAssets[index].unitCost = newCost;
                                                updatedAssets[index].totalValue = updatedAssets[index].receivingQty * (+newCost || 0);
                                                setAssetItems(updatedAssets);
                                                onUpdate(updatedAssets);
                                            }}
                                            onBlur={(e: any) => {
                                                const newCost = e.target.value;
                                                const updatedAssets = [...assetItems];
                                                updatedAssets[index].unitCost = isNaN(+newCost) ? 0 : (+newCost > -1 ? +newCost : 0);
                                                updatedAssets[index].totalValue = updatedAssets[index].receivingQty * updatedAssets[index].unitCost;
                                                setAssetItems(updatedAssets);
                                                onUpdate(updatedAssets);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`w-28 min-w-28 max-w-28 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-end flex-col bg-[#F9F9F9] cursor-not-allowed ${index < (assetItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                <div className={`preview-value line-clamp-1 text-right`}>{asset.orderedQty || 0} {asset.unitCode}</div>                                
                            </div>
                            <div className={`w-28 min-w-28 max-w-28 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-end flex-col bg-[#F9F9F9] cursor-not-allowed ${index < (assetItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                <div className={`preview-value line-clamp-1 text-right`}>{asset.deliveredQty || 0} {asset.unitCode}</div>                                
                            </div>
                            <div className={`w-28 min-w-28 max-w-28 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable ${index < (assetItems.length - 1) ? `border-b border-[#043E6133]` : ``}`} id={`part-item-qty-${index}`} onClick={(e: any) => {
                                handleOnClickCellEdit(`part-item-qty-${index}`, e);
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                                    <div className={`text-right`}>
                                        <div className={`preview-value`} title={+asset.receivingQty > 0? (asset.receivingQty + ` Each`): `Click here to add data`}>{asset.receivingQty || 0} {asset.unitCode}</div>
                                        <div className={`edit-value hidden`}>
                                            <div className={ `flex items-center justify-end gap-1` }>
                                                <input
                                                    type="tel"
                                                    className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right`}
                                                    value={asset.receivingQty || 0}
                                                    onChange={(e) => {
                                                        const newQty = +e.target.value;
                                                        const updatedAssets = [...assetItems];
                                                        updatedAssets[index].receivingQty = isNaN(newQty) ? 0 : newQty;
                                                        updatedAssets[index].totalValue = (updatedAssets[index].receivingQty * updatedAssets[index].unitCost);
                                                        setAssetItems(updatedAssets);
                                                        onUpdate(updatedAssets);
                                                    }}
                                                />
                                                <div className={`text-right`}>{asset.unitCode}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`w-28 min-w-28 max-w-28 font-normal text-[#42484B] text-[15px] px-2.5 py-3 bg-[#F9F9F9] cursor-not-allowed ${index < (assetItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                <div className={`preview-value text-right`}><Currency currency={ `USD` } value={asset.totalValue || 0} /></div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>            

        </div>
    );
};
export default CreateReceiptAssets;